import { render, staticRenderFns } from "./HomePageDocumentRequestManager.vue?vue&type=template&id=307f0d82&"
import script from "./HomePageDocumentRequestManager.vue?vue&type=script&lang=ts&"
export * from "./HomePageDocumentRequestManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports